import useTranslation from '../../hooks/useTranslation';
import { useSelector } from 'react-redux';
import { convertBigNumToDecimalString } from '../../utils/convert-decimal-to-big-num';
import timeFormAPI from '../../api/ui/timeFormAPI';
import { useEffect, useState } from 'react';
import { create } from './table-schema';
import {getEventState, getEventStateIcon} from '../../constants/event';
import {getPerIcon} from "../../api/ui/icons";

function useSchemaBasicMissionMain() {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.language.locale);

  /**
   * 헤더에 표시할 항목의 개수
   */
  const size = 8;

  /**
   * 테이블 헤더에 표시할 항목 문자열 배열
   */
  const headerKeys = [
    "admin.event.newUser.basicMissionMain.table.head.missionNo", // "미션 번호",
    "admin.event.newUser.basicMissionMain.table.head.state", // "상태",
    // "admin.event.newUser.basicMissionMain.table.head.walletNo", // "월렛 번호",
    // "admin.event.newUser.basicMissionMain.table.head.initialPer", // "PER 총 예산",
    // "admin.event.newUser.basicMissionMain.table.head.usedPer", // "사용된 PER",
    "admin.event.newUser.basicMissionMain.table.head.beginAt", // "시작 일시",
    "admin.event.newUser.basicMissionMain.table.head.endAt", // "종료 일시",
    "admin.event.newUser.basicMissionMain.table.head.conditionAt", // "일일 미션 시작 일시"
  ];

  /**
   * 서버로부터 전달받은 request를 테이블에 표시할 내용으로 변환한다.
   *
   * 오브젝트 키는 param1, param10 등의 형식으로 param 다음에 숫자를 붙여서 사용한다.
   *
   * param1은 헤더의 첫번째 표시되는 항목이다.
   *
   * 헤더에는 표시되지 않지만 상세에 표시될 항목의 경우 headSize 이후의 숫자를 사용한다.
   *
   * key는 반드시 있어야 한다.
   * @param {object} row
   * @returns
   */
  const parse = (row) => {

    const index = row?.index;
    const missionNo = row?.missionNo;
    const state = getEventStateIcon({startAt: row?.beginAt, endAt: row?.endAt, depositTransactionStatus: row?.depositTransactionStatus
    });
    const beginAt = timeFormAPI.changeDataLog(row?.beginAt);
    const endAt = timeFormAPI.changeDataLog(row?.endAt);
    const conditionAt = timeFormAPI.changeDataLog(row?.conditionAt);

    return {
      key: index, // 키는 반드시 있어야 한다.
      param1: missionNo,
      param2: state,
      param3: beginAt,
      param4: endAt,
      param5: conditionAt,
      missionNo: missionNo,
    };
  };

  /**
   * 로그 데이터를 클릭했을 때 보여줄 디테일 다이얼로그에 보여줄 항목을 작성한다.
   *
   * 입력값인 row는 위의 parse에서 변환된 값이다.
   *
   * @param {object} row
   * @returns
   */
  const details = (row) => {
    const array = [];
    if (row) {
      //
    }
    return array;
  };

  const [schema, setSchema] = useState();

  useEffect(() => {
    const headers = headerKeys.map((key) => t(key));
    const schema = create({
      headSize: size,
      heads: headers,
      parseFunc: parse,
      detailFunc: details,
    });
    setSchema(schema);
  }, [locale]);

  return { schema: schema };
}

export default useSchemaBasicMissionMain;
